/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ebr_Diff_Words_RemovedInputs */

const cs_ebr_diff_words_removed = /** @type {(inputs: Ebr_Diff_Words_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} slov`)
};

const en_ebr_diff_words_removed = /** @type {(inputs: Ebr_Diff_Words_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} words`)
};

/**
* | output |
* | --- |
* | "{count} words" |
*
* @param {Ebr_Diff_Words_RemovedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_words_removed = /** @type {((inputs: Ebr_Diff_Words_RemovedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_Words_RemovedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_words_removed(inputs)
	return cs_ebr_diff_words_removed(inputs)
});